<template>
  <BaseElSelect
    v-model="syncModel"
    filterable
    remote
    clearable
    reserve-keyword
    :placeholder="placeholder || '搜尋次卡名稱'"
    no-match-text="查無次卡"
    no-data-text="查無次卡"
    :remote-method="remoteSearch"
    :loading="loading"
    value-key="id"
    v-bind="$attrs"
    @change="$emit('change', find(dataList, {id: $event}))"
    @clear="getData"
  >
    <i slot="prefix" class="el-input__icon el-icon-search" />
    <BaseElSelectOption
      v-for="(item, index) in displayData"
      :key="item.id"
      :label="displayLabel(item, index)"
      :value="getKeyValue(item)"
    />
  </BaseElSelect>
</template>
<script>
import { GetPunchCard } from '@/api/punchCard'
import { mapGetters } from 'vuex'
import { find, isEmpty } from 'lodash'

export default {
  name: 'PunchCardSearch',
  props: ['model', 'objKey', 'customLabel', 'customFilter', 'placeholder'],

  computed: {
    ...mapGetters([
      'shop',
    ]),
    syncModel: {
      get () {
        return this.model
      },

      set (data) {
        this.$emit('update:model', data)
      },
    },

    displayData () {
      if (this.customFilter) return this.customFilter(this.dataList)
      const showList = this.dataList
      if (isEmpty(showList)) {
        if (this.model) {
          showList.push(this.model)
        }
      }
      return showList
    },

  },
  // :value="{name:item.UserInfo.name, phone:item.UserInfo.phone}"

  data: () => ({
    loading: false,
    dataList: [],
  }),

  async mounted () {
    await this.getData()
  },

  methods: {
    find,
    getKeyValue (item) {
      console.log(item[this.objKey])
      if (!this.objKey) return item
      return item[this.objKey]
    },
    displayLabel (item, index) {
      if (this.customLabel) return this.customLabel(item, index)
      return item.name
    },
    async remoteSearch (query) {
      query = query.trim()
      if (query === '') this.dataList = []

      try {
        this.loading = true
        setTimeout(async () => {
          await this.getData(query)
          this.loading = false
        }, 200)
      } catch (error) {
        console.log(error)
      }
    },

    async getData (query = null) {
      const [res, err] = await GetPunchCard({
        shopId: this.shop,
        name: (query) || undefined,
        limit: 50,
      })
      this.dataList = res
      if (err) {
        console.log(err)
      }
    },
  },
}
</script>

<style scoped lang="scss"></style>
